import React from 'react';
import { CheckIcon, LeafIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { noMas, todoIncluye } from '../data/megapack';
export function FinalSection() {
  return <section className="relative w-full overflow-hidden bg-forest-800 px-5 py-16 text-cream sm:py-20" aria-labelledby="final-title" data-id="element-64" data-mp="2y3matkndhfzs">
      <div className="paper-dots-light absolute inset-0 opacity-60" aria-hidden="true" data-id="element-65" data-mp="3314byov5eqx8" />

      <div className="relative mx-auto max-w-3xl text-center" data-id="element-66" data-mp="2ochyksp3098n">
        <h2 id="final-title" className="mx-auto max-w-xl font-display text-2xl font-extrabold leading-tight tracking-tight sm:text-4xl" data-id="element-67" data-mp="2t49iikdqfgpt">
          El próximo domingo podés seguir improvisando…
          <span className="mt-2 block text-gold-400" data-id="element-68" data-mp="2jeg4lcq4apie">
            o podés tener todo organizado desde hoy.
          </span>
        </h2>

        <ul className="mx-auto mt-9 max-w-xl space-y-2 rounded-3xl border-2 border-cream/15 bg-forest-900/50 p-6 text-left" data-id="element-69" data-mp="25fq7hx3aspu1">
          {noMas.map(item => <li key={item} className="flex items-start gap-2 text-[13px] text-cream/85" data-id="element-70" data-mp="2afumtjsgzeio">
              <span className="mt-0.5 text-lime-400" aria-hidden="true" data-id="element-71" data-mp="2wca85ycc2pq0">
                ▸
              </span>
              {item}
            </li>)}
        </ul>

        <p className="mx-auto mt-9 max-w-xl text-sm leading-relaxed text-cream/80 sm:text-base" data-id="element-72" data-mp="35dqg7zfoefr2">
          MegaPack Seño Jardín no te convierte en buena docente.{' '}
          <span className="font-extrabold text-cream" data-id="element-73" data-mp="2cpumn3lel3yi">Vos ya sos una buena docente.</span> Lo que hace
          el MegaPack es darte{' '}
          <span className="mark-lime-dark font-bold text-cream" data-id="element-74" data-mp="28pk8v4rdd993">
            más orden, más ideas y más herramientas
          </span>{' '}
          para que eso se note en tu día a día.
        </p>

        <div className="mt-12 rounded-3xl border-2 border-cream/15 bg-forest-900/50 p-6 text-left sm:p-8" data-id="element-75" data-mp="2ho5tr6kbd0d1">
          <h3 className="text-center font-display text-xl font-extrabold sm:text-2xl" data-id="element-76" data-mp="1tybhor7tjftu">
            Todo lo que incluye
          </h3>
          <ul className="mt-5 grid gap-2 sm:grid-cols-2" data-id="element-77" data-mp="1oyp6enbjw9no">
            {todoIncluye.map(item => <li key={item} className="flex items-start gap-2 text-[13px] text-cream/85" data-id="element-78" data-mp="3p2j3xgmduuuz">
                <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-lime-400" aria-hidden="true" data-id="element-79" data-mp="3u01cv70eha2z" />
                {item}
              </li>)}
          </ul>
        </div>

        <blockquote className="mx-auto mt-12 max-w-xl font-hand text-2xl leading-snug text-gold-400 sm:text-3xl" data-id="element-80" data-mp="7l9ktg7halk9">
          “El mejor momento para tener este material era al inicio del año. El segundo mejor momento es
          hoy.”
        </blockquote>

        <div className="mt-12 rounded-3xl border-4 border-gold-400 bg-forest-900 p-7 sm:p-9" data-id="element-81" data-mp="3b4uq2sqqgnzf">
          <p className="flex items-center justify-center gap-2 font-display text-xl font-extrabold sm:text-2xl" data-id="element-82" data-mp="3g4h5n8u1agbe">
            <LeafIcon className="h-6 w-6 text-lime-400" aria-hidden="true" data-id="element-83" data-mp="vbvq4zq3lrqk" />
            MegaPack Seño Jardín
          </p>
          <p className="mx-auto mt-4 max-w-lg text-[13px] leading-relaxed text-cream/80 sm:text-sm" data-id="element-84" data-mp="zcphy46nvqoq">
            Hecho para maestras jardineras y docentes de Nivel Inicial que quieren planificar con más
            calma, enseñar con más recursos y disfrutar más su año escolar.
          </p>

          <CtaButton className="mt-7" data-id="element-85" data-mp="2b2o7k21qxd68">Quiero mi MegaPack ahora</CtaButton>

          <p className="mt-5 text-[11px] font-bold uppercase tracking-wider text-cream/65" data-id="element-86" data-mp="2644ny8amkdh1">
            Garantía de 7 días · Pago seguro · Acceso inmediato · Mercado Pago
          </p>
        </div>
      </div>
    </section>;
}